import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TableEmptyState } from '../../TableEmptyState';

export const EmptyState: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full h-[400px] flex items-center justify-center">
      <TableEmptyState
        variant="analytics"
        title={t('charts.noDataToDisplay')}
        description={t('charts.noDataForPeriod')}
      />
    </div>
  );
};
